<template>
  <div class="h-full w-auto flex items-center" @click="$emit('answer')">
    <div class="flex-1 mr-5 border-blue-700 py-1 rounded-md" v-bind:class="[ chosen ? 'border-2 bg-blue-100 text-blue-600' : 'border bg-blue-200 hover:bg-blue-700 text-blue-800 hover:text-white hover:border-blue-300']">
      <div class="flex items-stretch">
        <div class="self-auto flex-1 m-2">
          <div class="relative h-6 w-6 border rounded-sm" v-bind:class="[ chosen ? 'text-white bg-blue-400 border-blue-600' : 'text-blue-700 bg-blue-100 border-blue-800']">
            <span class="w-11/50 h-11/50 flex flex-col items-center font-bold justify-center text-center">{{option.keystroke}}</span>
          </div>
        </div>
        <div class="flex-grow items-center py-2 pl-2">
          <div class="">{{option.value.display}}</div>
        </div>
        <div class="flex mr-2 w-5">
          <div class="inline-block flex justify-center items-center ml-1" v-if="chosen">
            <svg class="block fill-current transition-colors duration-200 ease-in-out" height="13" width="16"><path d="M14.293.293l1.414 1.414L5 12.414.293 7.707l1.414-1.414L5 9.586z"></path></svg>
          </div>
        </div>
      </div>
    </div>
    <button @click="$emit('utterance', option.value.display)"><svg role="img" width="28px" height="28px" viewBox="0 0 24 24" stroke="#215e4e" stroke-width="1" stroke-linecap="square" stroke-linejoin="miter" fill="none" color="#215e4e"> <title>Read question text</title> <path d="M13 5v14l-5-4H3V9h5z"/> <path stroke-linecap="round" d="M13 14c1.5-1 1.5-3 0-4"/> <path d="M16 16C18.0858253 13.9141747 18.0858253 10.0858253 16 8M18 19C21.98552 15.01448 22.0076803 9.00768033 18 5"/></svg></button>
  </div>
</template>
<script>
export default {
  props: ['chosen', 'option']
}
</script>